import { useNavigate, type NavigateOptions } from 'react-router-dom';
import { useCallback } from 'react';
import { flushSync } from 'react-dom';

const doc = document as Document & { startViewTransition?: (cb: () => void) => void };

export function useAnimatedNavigate() {
  const navigate = useNavigate();

  return useCallback(
    (to: string, opts?: NavigateOptions) => {
      if (doc.startViewTransition) {
        doc.startViewTransition(() => {
          flushSync(() => navigate(to, opts));
        });
      } else {
        navigate(to, opts);
      }
    },
    [navigate],
  );
}

/** Wrap any state update in a view transition so the content area cross-fades. */
export function withViewTransition(fn: () => void) {
  if (doc.startViewTransition) {
    doc.startViewTransition(() => flushSync(fn));
  } else {
    fn();
  }
}
